import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _values, _i, _size, _class2, _class3, _descriptor2, _descriptor3, _descriptor4;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { tracked } from "@glimmer/tracking";
import Evented from "@ember/object/evented";
import { cancel, later, schedule } from "@ember/runloop";
import Service, { service } from "@ember/service";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
import { bind } from "discourse-common/utils/decorators";
const STORE_LOADING_TIMES = 5;
const DEFAULT_LOADING_TIME = 0.3;
const MIN_LOADING_TIME = 0.1;
const STILL_LOADING_DURATION = 2;
let RollingAverage = (_class = (_values = /*#__PURE__*/new WeakMap(), _i = /*#__PURE__*/new WeakMap(), _size = /*#__PURE__*/new WeakMap(), class RollingAverage {
  constructor(size, initialAverage) {
    _initializerDefineProperty(this, "average", _descriptor, this);
    _classPrivateFieldInitSpec(this, _values, []);
    _classPrivateFieldInitSpec(this, _i, 0);
    _classPrivateFieldInitSpec(this, _size, void 0);
    _classPrivateFieldSet(_size, this, size);
    this.average = initialAverage;
  }
  record(value) {
    _classPrivateFieldGet(_values, this)[_classPrivateFieldGet(_i, this)] = value;
    _classPrivateFieldSet(_i, this, (_classPrivateFieldGet(_i, this) + 1) % _classPrivateFieldGet(_size, this));
    this.average = _classPrivateFieldGet(_values, this).reduce((p, c) => p + c, 0) / _classPrivateFieldGet(_values, this).length;
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "average", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var _scheduled = /*#__PURE__*/new WeakMap();
class ScheduleManager {
  constructor() {
    _classPrivateFieldInitSpec(this, _scheduled, []);
  }
  cancelAll() {
    _classPrivateFieldGet(_scheduled, this).forEach(s => cancel(s));
    _classPrivateFieldSet(_scheduled, this, []);
  }
  schedule() {
    _classPrivateFieldGet(_scheduled, this).push(schedule(...arguments));
  }
  later() {
    _classPrivateFieldGet(_scheduled, this).push(later(...arguments));
  }
}
var _startedAt = /*#__PURE__*/new WeakMap();
class Timer {
  constructor() {
    _classPrivateFieldInitSpec(this, _startedAt, void 0);
  }
  start() {
    _classPrivateFieldSet(_startedAt, this, Date.now());
  }
  stop() {
    return (Date.now() - _classPrivateFieldGet(_startedAt, this)) / 1000;
  }
}
let LoadingSlider = disableImplicitInjections(_class2 = (_class3 = class LoadingSlider extends Service.extend(Evented) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "siteSettings", _descriptor2, this);
    _initializerDefineProperty(this, "loading", _descriptor3, this);
    _initializerDefineProperty(this, "stillLoading", _descriptor4, this);
    _defineProperty(this, "rollingAverage", new RollingAverage(STORE_LOADING_TIMES, DEFAULT_LOADING_TIME));
    _defineProperty(this, "scheduleManager", new ScheduleManager());
    _defineProperty(this, "timer", new Timer());
  }
  get mode() {
    return this.siteSettings.page_loading_indicator;
  }
  get averageLoadingDuration() {
    return this.rollingAverage.average;
  }
  transitionStarted() {
    if (this.loading) {
      // Nested transition
      return;
    }
    this.timer.start();
    this.loading = true;
    this.trigger("stateChanged", true);
    this.scheduleManager.cancelAll();
    this.scheduleManager.later(this.setStillLoading, STILL_LOADING_DURATION * 1000);
  }
  transitionEnded() {
    if (!this.loading) {
      return;
    }
    let duration = this.timer.stop();
    if (duration < MIN_LOADING_TIME) {
      duration = MIN_LOADING_TIME;
    }
    this.rollingAverage.record(duration);
    this.loading = false;
    this.stillLoading = false;
    this.trigger("stateChanged", false);
    this.scheduleManager.cancelAll();
    this.scheduleManager.schedule("render", this.removeClasses);
  }
  setStillLoading() {
    this.stillLoading = true;
    this.scheduleManager.schedule("render", this.addStillLoadingClass);
  }
  addStillLoadingClass() {
    document.body.classList.add("still-loading");
  }
  removeClasses() {
    document.body.classList.remove("loading", "still-loading");
  }
}, (_descriptor2 = _applyDecoratedDescriptor(_class3.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "stillLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class3.prototype, "transitionEnded", [bind], Object.getOwnPropertyDescriptor(_class3.prototype, "transitionEnded"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "setStillLoading", [bind], Object.getOwnPropertyDescriptor(_class3.prototype, "setStillLoading"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "addStillLoadingClass", [bind], Object.getOwnPropertyDescriptor(_class3.prototype, "addStillLoadingClass"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "removeClasses", [bind], Object.getOwnPropertyDescriptor(_class3.prototype, "removeClasses"), _class3.prototype)), _class3)) || _class2;
export { LoadingSlider as default };